import type { ReactNode } from 'react';

export const symbol_call_split: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-698v93q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-165q0-12.75 8.63-21.38Q177.25-800 190-800h165q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-92l231 231q8 8 13 19.28 5 11.28 5 23.72v276q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-276L220-698Zm520 0L586-545q-8.8 9-20.9 9-12.1 0-21.1-9-9-9-9-21.2 0-12.19 9-20.8l153-153h-92q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h165q12.75 0 21.38 8.62Q800-782.75 800-770v165q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-93Z"
		/>
	</svg>
);
